import React from "react";

// nodejs library that concatenates classes
import classNames from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/defaultPage.js";

// Sections for this page
import HeaderSection from "views/Components/Sections/HeaderSection.js";

const useStyles = makeStyles(styles);

const BlogPage = (props) => {
  const classes = useStyles();
  return (
    <div>
      <HeaderSection props={props} />
      <Parallax filter image={require("assets/img/banner_02.png")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8}>
              <h1 className={classes.title}>Portofoliu</h1>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}></div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogPage;
